import React, { useState } from "react";
import { CheckmarkIcon } from "../../../Assets/images/svgs";
import "./style.css";

const SelectGroup = ({ label, buttons, onChange }) => {
  const [selected, setSelected] = useState(new Set(buttons.map(({ idx }) => idx)));

  const updateCheckboxes = (id) => {
    if(selected.has(id)) selected.delete(id)
    else selected.add(id)

    setSelected(new Set(selected));
    onChange(new Set(selected));
  }

  return (
    <div className="select-group">
      <p>{ label || "Select Buttons" }</p>
      <div className="checkbox-group">
        { buttons.map(btn => (
          <label key={btn.idx} className={`faulty-motor-checkboxes ${selected.has(btn.idx) && "checked-button-checkbox"}`}>
            {selected.has(btn.idx) && <CheckmarkIcon className="checkmark-icon" />}
            {btn.nm}
            <input type="checkbox" className="button-checkbox" onChange={() => updateCheckboxes(btn.idx)}/>
          </label>
        )) }
      </div>
    </div>
  )
}

export default SelectGroup